export * from './anchorTypes'
export * from './repeatTypes'
export * from './targeting'
export * from './timezone'
export * from './participantSession'
export * from './timingMode'
export * from './availabilityModes'
export * from './audienceTypes'
export * from './endRulesTypes'
export * from './defaultSchedule'
export * from './combineUi'

export const SCHEDULE_CONTRACT_VERSION = 1
export const SCHEDULE_METADATA_KEY = 'schedule'

/** @deprecated engine_schedules draft key — v2 uses metadata.schedule[] */
export const ENGINE_SCHEDULES_VERSION = 1
export const ENGINE_SCHEDULES_KEY = 'engine_schedules'
export const PARTICIPANT_SESSION_KEY = 'participant_session'
